import { Component } from '@angular/core';
import { LoginService } from '../../services/login/login.service';


@Component({
  selector: 'app-cobranzas',
  templateUrl: './cobranzas.component.html',
  styleUrls: ['./cobranzas.component.scss'],
})
export class CobranzasComponent {

  constructor(private loginService:LoginService) { }



  clickGuard(){
     this.loginService.clickGuard = true;
  }

}
